export const footer = () => {

  const footer = document.querySelector('footer');
  const MQL = window.matchMedia('(min-width: 768px)');

  let desktopColumns;
  let mobileColumns;
  let height;
  let offset;

  if (footer) {
    const dropdown = footer.querySelector('.js-communities-dropdown');
    const communitiesList = footer.querySelector('.js-communities-list');
    MQL.addListener(resizeHandler);

    function resizeHandler() {
      desktopColumns = (MQL.matches) ? 4 : 2;
      mobileColumns = (MQL.matches) ? 4 : 1;
      offset = (MQL.matches) ? 150 : 100;
      dropdown.classList.remove('open');
      communitiesList.classList.remove('show');
    }
    resizeHandler();

    function updateColumns() {
      let newHeight = height / desktopColumns + offset;
      communitiesList.style.height = newHeight + 'px';
    }

    const dropdownClickListener = (e) => {
      e.stopPropagation();
      dropdown.classList.toggle('open');
      communitiesList.classList.toggle('show');
      communitiesList.style.height = 'auto';
      height = communitiesList.getBoundingClientRect().height;
      updateColumns();
    }

    if (dropdown) {
      dropdown.addEventListener('click', dropdownClickListener);
    }
  }
}



// WEBPACK FOOTER //
// ./src/templates/components/footer/footer.js